import { render, staticRenderFns } from "./WebhookForm.vue?vue&type=template&id=05a8ac26&scoped=true&"
import script from "./WebhookForm.vue?vue&type=script&lang=js&"
export * from "./WebhookForm.vue?vue&type=script&lang=js&"
import style0 from "./WebhookForm.vue?vue&type=style&index=0&id=05a8ac26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a8ac26",
  null
  
)

export default component.exports